import { Injectable } from '@angular/core';
import { Association, Member, Office, Person, PersonRelationship } from '@tangilla/tg-ng-models';
import { Model } from 'survey-core';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {
  responseHeaderId: string | null = null;

  surveyModel!: Model;

  isPreview?: boolean;
  previewVersion?: string;

  formSource?: string;
  drWorkflow = false;
  personId: any = null;
  personRecord: Person | undefined;
  personRelationships: PersonRelationship[] = [];
  memberId: string | null = null;
  memberRecord: Member | any;
  officeId: string | null = null;
  officeRecord: Office | null = null;
  chargeable = true;
  searchByCorpLicense = false;
  isThompsonState = false;
  associationRecord: Association | null = null;

  isLoading = false;

  constructor() {
  }

  showNextButton(isVisible: boolean) {
    this.surveyModel.showNavigationButtons = isVisible;
  }

}
